import { ModelSagres } from "@/types/model-sagres";

export class AuditoresDiferentes extends ModelSagres {
    nomeAuditor: string
    cpfAuditor: string

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.Nome) this.nomeAuditor = obj.nome
            if (obj.Cpf) this.cpfAuditor = obj.cpf
        }
    }
}


